import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const TranslateSourceDataItemSkeleton = () => {
  return [...Array(3)].map((_) => (
    <tr key={uuidv4()} className={style.translateSourceDataRow}>
      <td>
        <SkeletonBlock className={style.skeletonTextClassName} />
      </td>
    </tr>
  ));
};

export default TranslateSourceDataItemSkeleton;
